import { css } from '@emotion/react'
import { colours } from './colours'
import {
  ActaAgate,
  ActaAgate2,
  ActaAgateB,
  ActaAgateB2,
  ActaDisplay,
  ActaDisplay2,
  ActaBook,
  ActaBook2,
  ActaBold,
  ActaBold2,
  ActaHeadlineBook,
  ActaHeadlineBook2,
  ActaHeadlineBookItalic,
  ActaHeadlineBookItalic2,
  FranklinGothicBook,
  FranklinGothicBook2,
  FranklinGothicDemi,
  FranklinGothicDemi2,
} from './fonts'

const global = css`
  @font-face {
    font-family: 'Acta Display';
    src: url(${ActaDisplay2}) format('woff2'),
      url(${ActaDisplay}) format('woff');
    font-weight: 800;
    font-style: normal;
  }

  @font-face {
    font-family: 'Acta Book';
    src: url(${ActaBook2}) format('woff2'), url(${ActaBook}) format('woff');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Acta Book';
    src: url(${ActaBold2}) format('woff2'), url(${ActaBold}) format('woff');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'Acta Sans';
    src: url(${ActaAgate2}) format('woff2'), url(${ActaAgate}) format('woff');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Acta Sans';
    src: url(${ActaAgateB2}) format('woff2'), url(${ActaAgateB}) format('woff');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'Acta Headline';
    src: url(${ActaHeadlineBook2}) format('woff2'),
      url(${ActaHeadlineBook}) format('woff');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Acta Headline';
    src: url(${ActaHeadlineBookItalic2}) format('woff2'),
      url(${ActaHeadlineBookItalic}) format('woff');
    font-weight: normal;
    font-style: italic;
  }

  @font-face {
    font-family: 'Franklin Gothic';
    src: url(${FranklinGothicBook2}) format('woff2'),
      url(${FranklinGothicBook}) format('woff');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Franklin Gothic';
    src: url(${FranklinGothicDemi2}) format('woff2'),
      url(${FranklinGothicDemi}) format('woff');
    font-weight: bold;
    font-style: normal;
  }

  .gatsby-image-wrapper {
    > img {
      filter: blur(30px);
    }
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: ${colours.bgWhite};
    color: black;
    &.dark {
      background-color: black;
    }
  }
`

export default global
